<li (click)="redirectToChatApp()">
  <a>
    ChatApp
  </a>
</li>
